import lottie from 'lottie-web';

export const LottieAnimations = (() => {
	'use strict';

	let lottieContainers;

	function init() {
		let lottieContainers = document.querySelectorAll('.lottie-container');

		if (lottieContainers) {
			lottieContainers.forEach(function (lottieContainer) {
				// loadLottieAnimation(lottieContainer);
				trackLottie(lottieContainer);
			});
		}
	}

	function checkLotties(lottieContainer) {
		var $lottie = $(lottieContainer);

		if (isInViewport(lottieContainer)) {
			if (!$lottie.data('loaded')) {
				loadLottieAnimation(lottieContainer);
			} else {
				$lottie.data('anim').play();
				$lottie.attr('data-status', 'playing');
			}
		} else {
			if ($lottie.data('loaded')) {
				var anim = $lottie.data('anim');
				anim.pause();
				$lottie.attr('data-status', 'paused');
			}
		}
	}

	function trackLottie(lottieContainer) {
		document.addEventListener(
			'scroll',
			function () {
				checkLotties(lottieContainer);
			},
			{
				passive: true,
			}
		);

		checkLotties(lottieContainer);
	}

	function isInViewport(el) {
		const rect = el.getBoundingClientRect();
		var elementTop = $(el).offset().top;
		var elementBottom = elementTop + $(el).outerHeight();
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height() + $(window).height() / 2;
		return elementBottom > viewportTop && elementTop < viewportBottom;
	}

	function loadLottieAnimation(el) {
		// console.log('found one', el.dataset.json);

		if (!$(el).data('loaded')) {
			var looping = el.dataset.loop == 'true';
			var anim = lottie.loadAnimation({
				container: el,
				renderer: 'svg',
				loop: looping,
				autoplay: true,
				path: el.dataset.json,
			});

			if (looping) {
				var loopFrame = parseInt(el.dataset.frame, 10) > 0 ? parseInt(el.dataset.frame, 10) : 0;
				$(anim).on('loopComplete', function () {
					console.log('loop complete');
					anim.stop();
					anim.goToAndPlay(loopFrame, true);
				});
			}

			$(el).attr('data-status', 'playing');

			$(el).data('loaded', true);
			$(el).data('anim', anim);
		}
	}

	return {
		init: init,
	};
})();
